import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=5ae5eb8a&scoped=true&"
import script from "./replacement.vue?vue&type=script&lang=js&"
export * from "./replacement.vue?vue&type=script&lang=js&"
import style0 from "./replacement.vue?vue&type=style&index=0&id=5ae5eb8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5eb8a",
  null
  
)

export default component.exports